import { runClientComponent } from '../../_common/client/client-component-runner';
import { PdpContentComponent } from './pdp-content.component';

runClientComponent({ PdpContentComponent });
